import { render, staticRenderFns } from "./CreateaFeedBackHidden.vue?vue&type=template&id=15ce8a71&scoped=true"
import script from "./CreateaFeedBackHidden.vue?vue&type=script&lang=js"
export * from "./CreateaFeedBackHidden.vue?vue&type=script&lang=js"
import style1 from "./CreateaFeedBackHidden.vue?vue&type=style&index=1&id=15ce8a71&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ce8a71",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15ce8a71')) {
      api.createRecord('15ce8a71', component.options)
    } else {
      api.reload('15ce8a71', component.options)
    }
    module.hot.accept("./CreateaFeedBackHidden.vue?vue&type=template&id=15ce8a71&scoped=true", function () {
      api.rerender('15ce8a71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/notify/CreateaFeedBackHidden.vue"
export default component.exports